function view (path) {
  return () => import(/* webpackChunkName: 'audit-v2' */ '@/views/audit/' + path + '.vue').then(m => m.default || m) // eslint-disable-line prefer-template
}

const RAudit = [
  {
    path: '/audit/dashboard',
    component: view('dashboard/Base'),
    name: 'audit.dashboard'
  },
  {
    path: '/audit/customers',
    component: view('Customers'),
    name: 'audit.customers',
    meta: {
      breadcrumb: [
        {
          text: 'Audit',
          to: {
            name: 'audit.dashboard'
          }
        },
        {
          text: 'Customers',
          active: true
        }
      ]
    }
  },
  {
    path: '/audit/customers/:customer?/managements',
    component: view('customer-management/Base'),
    name: 'audit.customers.profile',
    meta: {
      breadcrumb: [
        {
          text: 'Audit',
          to: {
            name: 'audit.dashboard'
          }
        },
        {
          text: 'Customers',
          to: {
            name: 'audit.customers'
          }
        },
        {
          text: 'Customer Profile',
          active: true
        }
      ]
    }
  }
]

const RAuditAreaManager = [
  {
    path: '/audit/area-managers',
    component: view('AreaManagerUsers'),
    name: 'audit.area-managers.users',
    meta: {
      breadcrumb: [
        {
          text: 'Audit',
          to: {
            name: 'audit.dashboard'
          }
        },
        {
          text: 'Area Managers'
        },
        {
          text: 'Users',
          active: true
        }
      ]
    }
  },
  {
    path: '/audit/area-managers/task-events',
    component: view('officer-events/Events'),
    name: 'audit.area-managers.events',
    meta: {
      breadcrumb: [
        {
          text: 'Audit',
          to: {
            name: 'audit.dashboard'
          }
        },
        {
          text: 'Area Managers'
        },
        {
          text: 'Task Events',
          active: true
        }
      ]
    }
  },
  {
    path: '/audit/area-managers/other-activities',
    component: view('officer-other-events/Base'),
    name: 'audit.area-managers.other-events',
    meta: {
      breadcrumb: [
        {
          text: 'Audit',
          to: {
            name: 'audit.dashboard'
          }
        },
        {
          text: 'Area Managers'
        },
        {
          text: 'Other Activities',
          active: true
        }
      ]
    }
  }
]

const RAuditReports = [
  {
    path: '/audit/reports/customers',
    component: view('reports/Customers'),
    name: 'audit.reports.customers',
    meta: {
      breadcrumb: [
        {
          text: 'Audit',
          to: {
            name: 'audit.dashboard'
          }
        },
        {
          text: 'Reports',
          to: {
            name: 'audit.reports.customers'
          }
        },
        {
          text: 'Customers',
          active: true
        }
      ]
    }
  },
  {
    path: '/audit/reports/area-managers/tasks',
    component: view('reports/Tasks'),
    name: 'audit.reports.area-managers-tasks',
    meta: {
      breadcrumb: [
        {
          text: 'Audit',
          to: {
            name: 'audit.dashboard'
          }
        },
        {
          text: 'Reports'
        },
        {
          text: 'Area Managers'
        },
        {
          text: 'Tasks',
          active: true
        }
      ]
    }
  },
  {
    path: '/audit/reports/area-managers/other-activities',
    component: view('reports/OtherEvents'),
    name: 'audit.reports.area-managers-other-events',
    meta: {
      breadcrumb: [
        {
          text: 'Audit',
          to: {
            name: 'audit.dashboard'
          }
        },
        {
          text: 'Reports'
        },
        {
          text: 'Area Managers'
        },
        {
          text: 'Other Activities',
          active: true
        }
      ]
    }
  }
]

export default RAudit.concat(
  RAuditAreaManager,
  RAuditReports
)
